import styled from "styled-components/native";

import { spacers } from "~/styles/theme";
import { MaxWidthBreakpoints, getWebContainerStyle } from "~/utils/web";

export const Container = styled.View`
  ${getWebContainerStyle(MaxWidthBreakpoints.Desktop)};
  padding-vertical: 100px;
`;
